var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',_vm._l((_vm.items),function(item){return _c('li',{key:item.text},[_c('settings-menu-item',{attrs:{"item":item}}),(item.items)?_c('settings-menu-list',{attrs:{"items":item.items}}):_vm._e()],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }